import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";

const CustomModal = ({ modelWrapperClass, open, onClose, title, children, sendLable ="Upload", onSave, disableBackdropClick = false }) => {

    const handleCancelClick = () => {
        onClose();
      };

      const handleSaveClick = () => {
        if(onSave){
          onSave();
        }
      };
  return (
      <Modal 
        open={open} 
        onClose={disableBackdropClick ? undefined : onClose}
        disableEscapeKeyDown={disableBackdropClick}
      >
        <Box className="modal-content" sx={modelWrapperClass}>
          <Typography className="modal-title">{title}</Typography>
          {children}
          <Box className='modal-btns'>
            <Button className="modal-cn-btn" onClick={() => handleCancelClick()}>Cancel</Button>
            <Button className="modal-save-btn" onClick={() => handleSaveClick()}>{sendLable}</Button>
          </Box>
        </Box>
      </Modal>
  );
};

export default CustomModal;
